import { render } from "./table-filter.vue?vue&type=template&id=5607f858"
import script from "./table-filter.vue?vue&type=script&lang=js"
export * from "./table-filter.vue?vue&type=script&lang=js"

import "./table-filter.vue?vue&type=style&index=0&id=5607f858&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__